const FormatDate = (dateString, formatLevel = 2) => {
    const shortMonths = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    const date = new Date(dateString);
    const day = date.getDate();
    const monthName = shortMonths[date.getMonth()];
    const year = date.getFullYear();

    // Format levels:
    // 0 (compact/smallest): "Dec 14 '25" - no ordinal, 2-digit year
    // 1 (medium): "Dec 14th 2025" - with ordinal, full year
    // 2 (full/largest): "Dec 14th 2025" - same as medium (could be extended to "December 14th 2025")
    
    if (formatLevel === 0 || formatLevel === 'compact') {
        // Compact format: "Dec 14 '25"
        const twoDigitYear = year.toString().slice(-2);
        return `${monthName} ${day} '${twoDigitYear}`;
    } else {
        // Full format: "Dec 14th 2025"
        // Determine the ordinal suffix
        let ordinalSuffix;
        if (day % 10 === 1 && day !== 11) {
            ordinalSuffix = "st";
        } else if (day % 10 === 2 && day !== 12) {
            ordinalSuffix = "nd";
        } else if (day % 10 === 3 && day !== 13) {
            ordinalSuffix = "rd";
        } else {
            ordinalSuffix = "th";
        }
        return `${monthName} ${day}${ordinalSuffix} ${year}`;
    }
}

export default FormatDate;